<template>
    <div
        class="photovoltaic-monitor"
        :style="`width:calc(100% - ${contWidth}px - 40px)`"
    >
        <el-scrollbar style="height: 100%;">
            <div class="content is-alway-shadow leader-tab">
                <!-- 电量 瞬时都没有  显示空页面 -->
                <template
                    v-if="
                        pointMsg.is_electricity == 0 &&
                            pointMsg.is_kind == 0 &&
                            pointMsg.selectTypeId == '0'
                    "
                ></template>
                <template v-else>
                    <el-tabs
                        v-model="tabVal"
                        type="card"
                        @tab-click="handleClick"
                    >
                        <el-tab-pane
                            label="光伏分析"
                            name="first"
                            v-if="
                                pointMsg.is_electricity == 1 ||
                                    pointMsg.selectTypeId != '0'
                            "
                        >
                            <div class="item_content_1">
                                <div class="search_cont">
                                    <el-form
                                        label-width="60px"
                                        :inline="true"
                                        :model="searchForm"
                                        class="leader-style-form"
                                    >
                                        <el-form-item label="时间">
                                            <el-date-picker
                                                v-model="searchForm.time"
                                                type="date"
                                                placeholder="选择日期"
                                                value-format="yyyy-MM-dd"
                                                format="yyyy-MM-dd"
                                                :picker-options="disableDate"
                                                :clearable="false"
                                                :editable="false"
                                                @change="search()"
                                            ></el-date-picker>

                                            <el-button
                                                class="leader-common-button"
                                                @click="lastDay"
                                                size="medium"
                                                >上一日</el-button
                                            >
                                            <el-button
                                                class="leader-common-button"
                                                :disabled="
                                                    this.sysDate ===
                                                        this.searchForm.time
                                                "
                                                @click="nextDay"
                                                size="medium"
                                                >下一日</el-button
                                            >
                                            <!-- <el-button
                                                class="leader-common-button"
                                                size="medium"
                                                @click="search"
                                                >查询</el-button
                                            >-->
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div class="elc_card_cont">
                                    <div
                                        class="pink elc_card_item"
                                        @click="searchWater('day')"
                                    >
                                        <div class="title_data title_data1">
                                            {{ dateSplice[2] }}日
                                        </div>
                                        <div style="width: 100%;">
                                            <div class="kwh_content">
                                                <b class="blue">{{ elc_day }}</b>
                                                <div class="unit">
                                                    {{ dayUnit }}
                                                </div>
                                            </div>
                                            <div class="noElc_content">
                                                当日无功电量：<b class="blue">{{ noElc_day
                                                }}</b>{{ redayUnit }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="perple elc_card_item"
                                        @click="searchWater('month')"
                                    >
                                       <div class="title_data title_data2">
                                            {{ dateSplice[1] }}月
                                        </div>
                                        <div style="width: 100%;">
                                            <div class="kwh_content">
                                                <b class="blue">{{ elc_month }}</b>
                                                <div class="unit">
                                                    {{ monthUnit }}
                                                </div>
                                            </div>
                                            <div class="noElc_content">
                                                当月无功电量：<b class="blue">{{ noElc_month
                                                }}</b>{{ remonthUnit }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="yellow elc_card_item"
                                        @click="searchWater('year')"
                                    >
                                        <div class="title_data title_data3">
                                            {{ dateSplice[0] }}年
                                        </div>
                                        <div style="width: 100%;">
                                            <div class="kwh_content">
                                                <b class="blue">{{ elc_year }}</b>
                                                <div class="unit">
                                                    {{ yearUnit }}
                                                </div>
                                            </div>
                                            <div class="noElc_content">
                                                当年无功电量：<b class="blue">{{ noElc_year
                                                }}</b>{{ reyearUnit }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="showYearChart">
                                    <div class="chart_cont">
                                        <div class="title">
                                            <div class="green"></div>
                                            {{ yearTitle }}年电量分时趋势
                                        </div>
                                        <div
                                            class="echart-container"
                                            v-loading="loading"
                                            element-loading-text="拼命加载中"
                                            element-loading-spinner="el-icon-loading"
                                            element-loading-background="rgba(0, 0, 0, 0.8)"
                                        >
                                            <el-button
                                                class="leader-common-button changeBtn"
                                                @click="year_chart_show = false"
                                                v-if="year_chart_show"
                                                >数据</el-button
                                            >
                                            <el-button
                                                class="leader-common-button changeBtn"
                                                @click="year_chart_show = true"
                                                v-else
                                                >图表</el-button
                                            >
                                            <v-chart
                                                :auto-resize="true"
                                                :options="yearBar"
                                                ref="yearBar"
                                                v-if="year_chart_show"
                                                @click="clickYearBar"
                                            />
                                            <el-table
                                                border
                                                class="leader-style-table"
                                                :data="year_tableList"
                                                height="18.75rem"
                                                v-else
                                            >
                                                <el-table-column
                                                    label="时间"
                                                    property="time"
                                                    align="center"
                                                ></el-table-column>

                                                <el-table-column
                                                    label="电量"
                                                    property="waterData"
                                                    align="center"
                                                ></el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="showMonthChart">
                                    <div class="chart_cont">
                                        <div class="title">
                                            <div class="green"></div>
                                            {{ monthTitle }}月电量趋势
                                        </div>
                                        <div
                                            class="echart-container"
                                            v-loading="loading"
                                            element-loading-text="拼命加载中"
                                            element-loading-spinner="el-icon-loading"
                                            element-loading-background="rgba(0, 0, 0, 0.8)"
                                        >
                                            <el-button
                                                class="leader-common-button changeBtn"
                                                @click="
                                                    month_chart_show = false
                                                "
                                                v-if="month_chart_show"
                                                >数据</el-button
                                            >
                                            <el-button
                                                class="leader-common-button changeBtn"
                                                @click="month_chart_show = true"
                                                v-else
                                                >图表</el-button
                                            >
                                            <v-chart
                                                :auto-resize="true"
                                                :options="monthBar"
                                                ref="monthBar"
                                                v-if="month_chart_show"
                                                @click="clickMonthBar"
                                            />
                                            <el-table
                                                border
                                                class="leader-style-table"
                                                :data="month_tableList"
                                                height="18.75rem"
                                                v-else
                                            >
                                                <el-table-column
                                                    label="时间"
                                                    property="time"
                                                    align="center"
                                                ></el-table-column>

                                                <el-table-column
                                                    label="电量"
                                                    property="waterData"
                                                    align="center"
                                                ></el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="showDayChart">
                                    <div class="chart_cont">
                                        <div class="title">
                                            <div class="green"></div>
                                            {{ dayTitle }}日电量分时趋势
                                        </div>
                                        <div
                                            class="echart-container"
                                            v-loading="loading"
                                            element-loading-text="拼命加载中"
                                            element-loading-spinner="el-icon-loading"
                                            element-loading-background="rgba(0, 0, 0, 0.8)"
                                        >
                                            <el-button
                                                class="leader-common-button changeBtn"
                                                @click="day_chart_show = false"
                                                v-if="day_chart_show"
                                                >数据</el-button
                                            >
                                            <el-button
                                                class="leader-common-button changeBtn"
                                                @click="day_chart_show = true"
                                                v-else
                                                >图表</el-button
                                            >
                                            <v-chart
                                                :auto-resize="true"
                                                :options="dayBar"
                                                ref="dayBar"
                                                v-if="day_chart_show"
                                            />
                                            <el-table
                                                border
                                                class="leader-style-table"
                                                :data="day_tableList"
                                                height="18.75rem"
                                                v-else
                                            >
                                                <el-table-column
                                                    label="时间"
                                                    property="time"
                                                    align="center"
                                                ></el-table-column>

                                                <el-table-column
                                                    label="电量"
                                                    property="waterData"
                                                    align="center"
                                                ></el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane
                            label="瞬时量趋势分析"
                            name="second"
                            v-if="pointMsg.is_kind == 1"
                        >
                            <div class="item_content_2">
                                <Instant :nowClick="shnowClick"></Instant>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import "@/assets/css/style.scss";
import Instant from "./instant";
import utils from "@/utils/utils.js";
import * as api from "../../../../http/Use_electricity_monitor";
import moment from "moment";
export default {
    components: {
        Instant
    },
    props: {
        nowClick: {
            type: Array
        },
        contWidth: {
            type: String
        }
    },
    data() {
        return {
            searchForm: {
                time: ""
            },
            tabVal: "first",
            loading: false,
            // xAxis: [
            //     {
            //         name: '时',
            //         type: 'category',
            //         data: [],
            //     },
            // ],
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            dateSplice: [],
            pointMsg: "",
            elc_day: "",
            noElc_day: "",
            elc_month: "",
            noElc_month: "",
            elc_year: "",
            noElc_year: "",
            chart_show: false,
            xList: [],
            sysDate: "",
            bigWidth: "calc(100% - 56px)",
            smallWidth: "calc(100% - 300px)",
            dayUnit: "",
            monthUnit: "",
            yearUnit: "",
            redayUnit: "",
            remonthUnit: "",
            reyearUnit: "",
            month_max: "",
            month_min: "",
            shnowClick: {},
            day_title: "",
            month_title: "",
            year_title: "",
            day_chart_show: true,
            month_chart_show: true,
            year_chart_show: true,
            day_tableList: [],
            day_xAxis: [],
            day_series: [
                {
                    name: "尖电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F97464'
                            }, {
                                offset: 1,
                                color: '#FB3737'
                            }]),
                        }
                    },
                },
                {
                    name: "峰电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F5E3B7'
                            }, {
                                offset: 1,
                                color: '#CB7A07'
                            }]),
                        }
                    },
                },
                {
                    name: "平电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#06B4F9'
                            }, {
                                offset: 1,
                                color: '#092856'
                            }]),
                        }
                    },
                },
                {
                    name: "谷电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#8CCFA5'
                            }, {
                                offset: 1,
                                color: '#1F924A'
                            }]),
                        }
                    },
                }
            ],
            month_tableList: [],
            month_xAxis: [],
            month_series: [
                {
                    name: "尖电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F97464'
                            }, {
                                offset: 1,
                                color: '#FB3737'
                            }]),
                        }
                    },
                },
                {
                    name: "峰电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F5E3B7'
                            }, {
                                offset: 1,
                                color: '#CB7A07'
                            }]),
                        }
                    },
                },
                {
                    name: "平电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#06B4F9'
                            }, {
                                offset: 1,
                                color: '#092856'
                            }]),
                        }
                    },
                },
                {
                    name: "谷电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#8CCFA5'
                            }, {
                                offset: 1,
                                color: '#1F924A'
                            }]),
                        }
                    },
                }
            ],
            year_tableList: [],
            year_xAxis: [],
            year_series: [
                {
                    name: "尖电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F97464'
                            }, {
                                offset: 1,
                                color: '#FB3737'
                            }]),
                        }
                    },
                },
                {
                    name: "峰电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F5E3B7'
                            }, {
                                offset: 1,
                                color: '#CB7A07'
                            }]),
                        }
                    },
                },
                {
                    name: "平电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#06B4F9'
                            }, {
                                offset: 1,
                                color: '#092856'
                            }]),
                        }
                    },
                },
                {
                    name: "谷电量",
                    type: "bar",
                    stack: "elc",
                    data: [],
                    barWidth: 22,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#8CCFA5'
                            }, {
                                offset: 1,
                                color: '#1F924A'
                            }]),
                        }
                    },
                }
            ],
            showDayChart: false, //显示日的图表
            showMonthChart: false, //显示月的图表
            showYearChart: false //显示年的图表
        };
    },
    methods: {
        //获取系统时间
        getSysDate() {
            api.getSysDate({}).then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate;
                    this.sysDate = res.bus_json.sysdate;
                    this.dateSplice = this.searchForm.time.split("-");
                    this.yearTitle = this.dateSplice[0];
                    this.monthTitle = this.dateSplice[1];
                    this.dayTitle = this.dateSplice[2];
                    // 获取日对的图表
                    this.showDayChart = true;
                    console.log("this.pointMsg: ", this.pointMsg);
                    if (this.pointMsg.selectTypeId == "0") {
                        this.getElecInfo(this.searchForm.time);
                    } else {
                        this.getUnitElecInfo(this.searchForm.time);
                    }
                }
            });
        },
        getElecTreeInfoYear(searchTime) {
            api.getElecUnitTreeList({
                tree_unit_id: this.pointMsg.tree_unit_id,
                date: searchTime
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.year_xAxis = res.bus_json.time_list;
                    this.year_series[0].data = res.bus_json.sharp_power_list;
                    this.year_series[1].data = res.bus_json.peak_power_list;
                    this.year_series[2].data = res.bus_json.off_power_list;
                    this.year_series[3].data = res.bus_json.shoulder_power_list;
                    this.year_chart_show = true;
                    this.year_tableList = [];
                    this.year_xAxis.forEach((item, i) => {
                        this.year_tableList.push({
                            time: item,
                            waterData: res.bus_json.active_power_list[i]
                        });
                    });
                }
            });
        },
        // 年
        getElecInfoYear(searchTime) {
            api.getElecList({
                point_id: this.pointMsg.point_id,
                date: searchTime
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.year_xAxis = res.bus_json.time_list;
                    this.year_series[0].data = res.bus_json.sharp_power_list;
                    this.year_series[1].data = res.bus_json.peak_power_list;
                    this.year_series[2].data = res.bus_json.off_power_list;
                    this.year_series[3].data = res.bus_json.shoulder_power_list;
                    this.year_chart_show = true;
                    this.year_tableList = [];
                    this.year_xAxis.forEach((item, i) => {
                        this.year_tableList.push({
                            time: item,
                            waterData: res.bus_json.active_power_list[i]
                        });
                    });
                }
            });
        },
        getElecTreeInfoMonth(searchTime) {
            api.getElecUnitTreeList({
                tree_unit_id: this.pointMsg.tree_unit_id,
                date: searchTime
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.month_xAxis = res.bus_json.time_list;
                    this.month_series[0].data = res.bus_json.sharp_power_list;
                    this.month_series[1].data = res.bus_json.peak_power_list;
                    this.month_series[2].data = res.bus_json.off_power_list;
                    this.month_series[3].data =
                        res.bus_json.shoulder_power_list;
                    this.month_chart_show = true;
                    this.month_tableList = [];
                    this.month_xAxis.forEach((item, i) => {
                        this.month_tableList.push({
                            time: item,
                            waterData: res.bus_json.active_power_list[i]
                        });
                    });
                }
            });
        },
        // 月
        getElecInfoMonth(searchTime) {
            api.getElecList({
                point_id: this.pointMsg.point_id,
                date: searchTime
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.month_xAxis = res.bus_json.time_list;
                    this.month_series[0].data = res.bus_json.sharp_power_list;
                    this.month_series[1].data = res.bus_json.peak_power_list;
                    this.month_series[2].data = res.bus_json.off_power_list;
                    this.month_series[3].data =
                        res.bus_json.shoulder_power_list;
                    this.month_chart_show = true;
                    this.month_tableList = [];
                    this.month_xAxis.forEach((item, i) => {
                        this.month_tableList.push({
                            time: item,
                            waterData: res.bus_json.active_power_list[i]
                        });
                    });
                }
            });
        },
        clickYearBar(chartParam) {
            this.showMonthChart = true;
            this.monthTitle = chartParam.name;
            this.getElecInfoMonth(chartParam.name);
        },
        clickMonthBar(chartParam) {
            this.showDayChart = true;
            this.dayTitle = chartParam.name;
            this.getElecInfo(chartParam.name, true);
        },
        // 根据pointid和时间获取数据 日
        getElecInfo(searchTime, noChange) {
            this.loading = true;
            api.getElecInfo({
                point_id: this.pointMsg.point_id,
                date: searchTime
            }).then(res => {
                if (res && res.error_code === "0") {
                    if (!noChange) {
                        this.elc_day = res.bus_json.active_power_day;
                        this.noElc_day = res.bus_json.reactive_power_day;
                        this.elc_month = res.bus_json.active_power_month;
                        this.noElc_month = res.bus_json.reactive_power_month;
                        this.elc_year = res.bus_json.active_power_year;
                        this.noElc_year = res.bus_json.reactive_power_year;
                        this.dayUnit = res.bus_json.dayUnit;
                        this.monthUnit = res.bus_json.monthUnit;
                        this.yearUnit = res.bus_json.yearUnit;
                        this.redayUnit = res.bus_json.redayUnit;
                        this.remonthUnit = res.bus_json.remonthUnit;
                        this.reyearUnit = res.bus_json.reyearUnit;
                        this.month_max = res.bus_json.month_max;
                        this.month_min = res.bus_json.month_min;
                    }
                    this.day_xAxis = res.bus_json.hour_list;
                    this.day_series[0].data = res.bus_json.sharp_power_list;
                    this.day_series[1].data = res.bus_json.peak_power_list;
                    this.day_series[2].data = res.bus_json.off_power_list;
                    this.day_series[3].data = res.bus_json.shoulder_power_list;
                    this.day_chart_show = true;
                    this.day_tableList = [];
                    this.day_xAxis.forEach((item, i) => {
                        this.day_tableList.push({
                            time: item,
                            waterData: res.bus_json.active_power_list[i]
                        });
                    });
                    // loading.close();
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            });
        },
        getUnitElecInfo(searchTime, noChange) {
            this.loading = true;
            api.getUnitElecInfo({
                tree_unit_id: this.pointMsg.tree_unit_id,
                date: searchTime
            }).then(res => {
                if (res && res.error_code === "0") {
                    if (!noChange) {
                        this.elc_day = res.bus_json.active_power_day;
                        this.noElc_day = res.bus_json.reactive_power_day;
                        this.elc_month = res.bus_json.active_power_month;
                        this.noElc_month = res.bus_json.reactive_power_month;
                        this.elc_year = res.bus_json.active_power_year;
                        this.noElc_year = res.bus_json.reactive_power_year;
                        this.dayUnit = res.bus_json.dayUnit;
                        this.monthUnit = res.bus_json.monthUnit;
                        this.yearUnit = res.bus_json.yearUnit;
                        this.redayUnit = res.bus_json.redayUnit;
                        this.remonthUnit = res.bus_json.remonthUnit;
                        this.reyearUnit = res.bus_json.reyearUnit;
                        this.month_max = res.bus_json.month_max;
                        this.month_min = res.bus_json.month_min;
                    }
                    this.day_xAxis = res.bus_json.hour_list;
                    this.day_series[0].data = res.bus_json.sharp_power_list;
                    this.day_series[1].data = res.bus_json.peak_power_list;
                    this.day_series[2].data = res.bus_json.off_power_list;
                    this.day_series[3].data = res.bus_json.shoulder_power_list;
                    this.day_chart_show = true;
                    this.day_tableList = [];
                    this.day_xAxis.forEach((item, i) => {
                        this.day_tableList.push({
                            time: item,
                            waterData: res.bus_json.active_power_list[i]
                        });
                    });
                    // loading.close();
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            });
        },
        /**
         * @description: 点击上面年月日的事件
         */
        searchWater(type) {
            this.dateSplice = this.searchForm.time.split("-");
            if (type == "day") {
                this.showDayChart = true; // 显示日
                this.showMonthChart = false; //不显示yue
                this.showYearChart = false; //不显示年
                this.dayTitle = this.dateSplice[2];
                if (this.pointMsg.selectTypeId == "0") {
                    // 这是采集点
                    this.getElecInfo(this.searchForm.time);
                } else {
                    // 这是部门和区域
                    this.getUnitElecInfo(this.searchForm.time);
                }
            } else if (type == "month") {
                this.showDayChart = false; //不显示日
                this.showMonthChart = true; // 显示月
                this.showYearChart = false; // 不显示年
                this.monthTitle = this.dateSplice[1];
                if (this.pointMsg.selectTypeId == "0") {
                    this.getElecInfoMonth(
                        // 这是采集点
                        this.dateSplice[0] + "-" + this.dateSplice[1]
                    );
                } else {
                    // 这是部门和区域
                    this.getElecTreeInfoMonth(
                        this.dateSplice[0] + "-" + this.dateSplice[1]
                    );
                }
            } else if (type == "year") {
                this.showDayChart = false;
                this.showMonthChart = false;
                this.showYearChart = true;
                this.yearTitle = this.dateSplice[0];
                if (this.pointMsg.selectTypeId == "0") {
                    // 这是采集点
                    this.getElecInfoYear(this.dateSplice[0]);
                } else {
                    // 这是部门和区域
                    this.getElecTreeInfoYear(this.dateSplice[0]);
                }
            }
        },
        // 搜索
        search() {
            this.dateSplice = this.searchForm.time.split("-");
            this.yearTitle = this.dateSplice[0];
            this.monthTitle = this.dateSplice[1];
            this.dayTitle = this.dateSplice[2];
            if (this.pointMsg.selectTypeId == "0") {
                // 这是采集点
                this.getElecInfo(this.searchForm.time);
            } else {
                // 这是部门区域
                this.getUnitElecInfo(this.searchForm.time);
            }
        },
        //上一日
        lastDay() {
            const now = moment(this.searchForm.time);
            this.searchForm.time = now.subtract(1, "days").format("YYYY-MM-DD");
            this.search();
            this.dateSplice = this.searchForm.time.split("-");
            this.showDayChart = true;
            this.showMonthChart = false;
            this.showYearChart = false;
        },
        // 下一日
        nextDay() {
            const now = moment(this.searchForm.time);
            this.searchForm.time = now.add(1, "days").format("YYYY-MM-DD");
            this.search();
            this.dateSplice = this.searchForm.time.split("-");
            this.showDayChart = true;
            this.showMonthChart = false;
            this.showYearChart = false;
        },
        handleClick(tab) {
            if (tab.index == 1) {
                // 瞬时
                this.shnowClick = this.nowClick;
            } else {
                // 电量
            }
        }
    },
    mounted() {
        this.getSysDate();
    },
    computed: {
        dayBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电量", "峰电量", "平电量", "谷电量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.day_xAxis,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位：kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.day_series
            };
            return options;
        },
        monthBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电量", "峰电量", "平电量", "谷电量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.month_xAxis,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位：kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.month_series
            };
            return options;
        },
        yearBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电量", "峰电量", "平电量", "谷电量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.year_xAxis,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位：kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.year_series
            };
            return options;
        }
    },
    watch: {
        nowClick: {
            handler(newValue) {
                this.pointMsg = newValue;
                // 初次进入时，如果有电量，显示电量tab页
                if (this.pointMsg.selectTypeId == "0") {
                    // 这是采集点
                    if (this.pointMsg.is_electricity == 1) {
                        this.tabVal = "first";
                    } else {
                        // 如果没有电量，显示瞬时tab页
                        this.tabVal = "second";
                    }
                    this.shnowClick = newValue;
                } else {
                    // 这是部门和区域
                    this.tabVal = "first";
                }
                if (this.searchForm.time) {
                    if (this.pointMsg.selectTypeId == "0") {
                        this.getElecInfo(this.searchForm.time);
                    } else {
                        this.getUnitElecInfo(this.searchForm.time);
                    }
                } else {
                    this.getSysDate();
                }
            },
            deep: true,
            immediate: true
        },
        contWidth: {
            handler(newValue) {
                console.log(newValue);
                return newValue;
            },
            deep: true,
            immediate: true
        }
    }
};
</script>

<style lang="scss">
.photovoltaic-monitor {
    //   width: calc(100% - 280px);
    //   width: 100%;
    //   box-sizing: border-box;
    //   padding: 0 20px 10px 20px;
    margin: 0 px2Rem(20px);

    .content {
        width: 100%;
        .el-tabs--card {
            margin: 0;
        }
    }
    .item_content_1 {
        width: 100%;
        .search_cont {
            width: 100%;
            .time_btn {
                background: #29b85e;
                color: #fff;
            }
        }
        .elc_card_cont {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .elc_card_item {
                width: 30%;
                height: px2Rem(120px);
                margin: px2Rem(10px);
                cursor: pointer;
                .title {
                    line-height: px2Rem(26px);
                    color: #fff;
                    // @include font_color;
                    font-size: px2Rem(16px);
                    text-align: left;
                    // width: 25%;
                    height: px2Rem(20px);
                    padding: 0.6rem;
                }
                .title_data{float:right;color:#00ffff;height:100%;width:26%;margin-right: px2Rem(3px);text-align: center; font-size: px2Rem(26px);
                background-size: 100% 100%;line-height: px2Rem(60px);}
                .title_data1{background: url("../../../../assets/image/use_electricity_monitor/day.png") no-repeat;}
                 .title_data2{background: url("../../../../assets/image/use_electricity_monitor/month.png") no-repeat;}
                  .title_data3{background: url("../../../../assets/image/use_electricity_monitor/year.png") no-repeat;}
                .kwh_content {
                    color: #fff;
                    font-size: px2Rem(25px);
                    line-height: px2Rem(20px);
                    text-align: left;
                    padding: px2Rem(30px) px2Rem(20px) px2Rem(0px);
                    .unit {
                        font-size: px2Rem(16px);
                        display: inline;
                    }
                }
                .blue{color: #00ffff;font-size: px2Rem(26px);}
                .noElc_content {
                    color: #fff;
                    // @include font_color;
                    font-size: px2Rem(20px);
                    line-height: px2Rem(30px);
                    text-align: left;
                    padding: px2Rem(10px) px2Rem(20px);
                }
            }
            .pink {
                width: 100%;
                background: url("../../../../assets/image/use_electricity_monitor/pinkBG.png")
                    no-repeat;
                background-size: 100% 100%;
            }
            .perple {
                width: 100%;
                background: url("../../../../assets/image/use_electricity_monitor/pinkBG.png")
                    no-repeat;
                background-size: 100% 100%;
            }
            .yellow {
                width: 100%;
                background: url("../../../../assets/image/use_electricity_monitor/pinkBG.png")
                    no-repeat;
                background-size: 100% 100%;
            }
        }
        .chart_cont {
            margin-top: px2Rem(20px);
            .title {
                .green {
                    height: px2Rem(12px);
                    width: px2Rem(5px);
                    background:  #9ba1e9;
                    margin: px2Rem(10px);
                    float: left;
                }
                width: 100%;
                font-size: px2Rem(16px);
                text-align: left;
                line-height: px2Rem(32px);
                height: px2Rem(32px);
                border-bottom: 0px solid #dddddd;
                color:  #9ba1e9;
            }
            .echart-container {
                width: 100%;
                //   height: calc(100% - px2Rem(265px));
                position: relative;
                .changeBtn {
                    position: absolute;
                    top: 0;
                    right: 20px;
                    z-index: 9;
                }
                .echarts {
                    width: 100%;
                    height: px2Rem(360px);
                }
                .leader-style-table {
                    width: calc(100% - 17px);
                }
            }
        }
    }
    .item_content_2 {
        width: 100%;
    }
}
.el-card {
    // order: 1px solid #ebeef5;
    // background-color: #fff;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}
.is-alway-shadow {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
